import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
    Box, Grid, TextField, Typography, Autocomplete, Button,
    FormControlLabel, Checkbox,
} from "@mui/material";
import { styles } from "../../utils/styles";

const DRAFT_KEY = 'onboarding_draft';

const loadStepData = (stepIndex) => {
    try {
        const raw = window.localStorage.getItem(DRAFT_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        return data.allFormData ? data.allFormData[stepIndex] : null;
    } catch (e) {
        console.error('Failed to load step data from storage:', e);
        return null;
    }
};

// Validation Schema for Step 5 Final
const getStep5ValidationSchema = (hideCheckbox) => Yup.object().shape({
    remarks: Yup.string().nullable(),
    ...(hideCheckbox ? {} : { approval_checkbox: Yup.boolean().oneOf([true], "You must confirm the checks") }),
});

const Step5Final = ({ onNext, onBack, onSkip, isSubmitting, activeBusinessEntity, businessEntityName, readOnly, hideCheckbox }) => {

    // Initial values
    const initialValues = loadStepData(4) || {
        remarks: "",
        approval_checkbox: false,
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={getStep5ValidationSchema(hideCheckbox)}
            onSubmit={(values) => {
                // Handle form submission if needed, but buttons are separate
            }}
            validateOnMount={false}
            validateOnChange={false}
            validateOnBlur={true}
            enableReinitialize={true}
        >
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting: formikSubmitting }) => (
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={4} sx={{ py: 2, px: 2 }}>
                        <Grid item xs={12}>
                            <Typography variant="h6" my={1}>
                                Final Approval
                            </Typography>
                            <Grid container spacing={2} alignItems="center">

                                {/* Remarks */}
                                <Grid item xs={12} sm={3}>
                                    <Typography align="right">Remarks</Typography>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <TextField
                                        label="Remarks"
                                        margin="dense"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        id="remarks"
                                        name="remarks"
                                        size="small"
                                        color="secondary"
                                        value={values.remarks}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={isSubmitting || readOnly}
                                    />
                                </Grid>

                                {/* Approval Checkbox */}
                                {!hideCheckbox && (
                                    <>
                                        <Grid item xs={12} sm={3}>
                                            <Typography align="right"></Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="approval_checkbox"
                                                        checked={values.approval_checkbox}
                                                        onChange={handleChange}
                                                        disabled={isSubmitting || readOnly}
                                                    />
                                                }
                                                label={`I have reviewed the details and hereby confirm my approval for ${businessEntityName || 'the business entity'} to proceed with onboarding.`}
                                            />
                                            {touched.approval_checkbox && errors.approval_checkbox && (
                                                <Typography variant="caption" color="error">
                                                    {errors.approval_checkbox}
                                                </Typography>
                                            )}
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={3}></Grid>

                        {/* Buttons */}
                        <Grid item xs={12} >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
                                <Button onClick={onBack} variant="outlined" disabled={isSubmitting || readOnly}>
                                    Back
                                </Button>
                                {/* Check if readOnly is false then just show the buttons, if readOnly is true then dont show anything*/}
                                {readOnly ? (
                                    <></>
                                ) : (
                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            onClick={() => onNext('reject', values)}
                                            disabled={isSubmitting || readOnly || (!hideCheckbox && !values.approval_checkbox)}
                                        >
                                            Reject
                                        </Button>
                                        <Button
                                            type="button"
                                            variant="contained"
                                            onClick={() => onNext('approve', values)}
                                            disabled={isSubmitting || readOnly || (!hideCheckbox && !values.approval_checkbox)}
                                            sx={{ ...styles.customButton }}
                                        >
                                            {isSubmitting ? 'Approving...' : 'Approve'}
                                        </Button>
                                    </Box>
                                )}


                            </Box>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};

export default Step5Final;